// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export function composeFilters() {
    var predicates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        predicates[_i] = arguments[_i];
    }
    return predicates.some(Boolean)
        ? function (item) {
            for (var _i = 0, predicates_1 = predicates; _i < predicates_1.length; _i++) {
                var predicate = predicates_1[_i];
                if (predicate && !predicate(item)) {
                    return false;
                }
            }
            return true;
        }
        : null;
}
